import { SOURCE, Source } from "@/constants";
import { cx } from "@/utils";

import GenericCover from "./partials/GenericCover";
import InstagramCover from "./partials/InstagramCover";
import TiktokCover from "./partials/TiktokCover";
import YoutubeCover from "./partials/YoutubeCover";

import styles from "./Cover.module.css";

/** Define what aspect ratio the thumbnail of a given source media has */

const SIZES: Record<string, Source[]> = {
  SQUARE: [
    SOURCE.PODCAST,
    SOURCE.RADIO,
    SOURCE.MANUAL,
    SOURCE.TWITTER,
    SOURCE.INSTAGRAM,
    SOURCE.FACEBOOK,
    SOURCE.LINKEDIN,
  ],
  PHOTO: [],
  VIDEO: [SOURCE.YOUTUBE, SOURCE.TV, SOURCE.WEB_TV, SOURCE.NEWS],
  VERTICAL_VIDEO: [SOURCE.TIKTOK],
};

type CoverProps = {
  className?: string;
  dumb?: boolean;
  episodeUrl: string;
  episodeGuid: string;
  source: Source;
  cover: string;
};

const Cover: React.FunctionComponent<CoverProps> = ({
  className,
  source,
  cover,
  episodeUrl,
  episodeGuid,
  dumb = false,
}) => {
  let inner = null;

  if (dumb) {
    inner = <GenericCover source={source} cover={cover} />;
  } else {
    switch (source) {
      case SOURCE.TIKTOK:
        inner = (
          <TiktokCover episodeUrl={episodeUrl} episodeGuid={episodeGuid} />
        );
        break;
      case SOURCE.INSTAGRAM:
        inner = <InstagramCover episodeUrl={episodeUrl} />;
        break;
      case SOURCE.YOUTUBE:
        inner = <YoutubeCover cover={cover} />;
        break;
      default:
        inner = <GenericCover source={source} cover={cover} />;
    }
  }

  return (
    <div
      className={cx(styles.root, className, {
        [styles.video]: SIZES.VIDEO.includes(source),
        [styles.verticalVideo]: SIZES.VERTICAL_VIDEO.includes(source),
        [styles.square]: SIZES.SQUARE.includes(source),
        [styles.photo]: SIZES.PHOTO.includes(source),
      })}
    >
      {inner}
    </div>
  );
};

export default Cover;
